
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject, Subscription} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ConfessionService} from '../../../../core/services/confession.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../../core/fuseUtils';
import {FormGroup} from '@angular/forms';
import {DynamicDataFormDialogComponent} from './setting-form/setting-form.component';
import {DynamicDataService} from "../../../../core/services/dynamicData.service";
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dynamicData-page',
    templateUrl: './dynamicData.component.html',
    styleUrls: ['./dynamicData.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class DynamicDataComponent implements OnInit, OnDestroy {
  dynamicDatas: FilesDataSource | null;
  displayedColumns = [ 'name', 'text', 'description' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dialogRef: any;
  public subscription = new Subscription();

  constructor (private http: HttpClient , private organizationTypesService: DynamicDataService,
               public dialog: MatDialog,  public snackBar: MatSnackBar, public translate: TranslateService) {
  }

  ngOnInit () {
    this.getDataType();
    this.subscription.add(this.translate.onLangChange.subscribe(res => {
      this.organizationTypesService.getDynamicDatas().then();
    }));
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  getDataType () {
    this.dynamicDatas = new FilesDataSource(this.organizationTypesService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged())
      .subscribe(() => {
        if (!this.dynamicDatas) {
          return;
        }
        this.dynamicDatas.filter = this.filter.nativeElement.value;
      });
  }

  newType () {
    this.dialogRef = this.dialog.open(DynamicDataFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: FormGroup) => {
        if (response) {
          const data = response.value;
          data.lang = this.translate.currentLang;
          this.organizationTypesService.addDynamicData(data).subscribe((res) => {
            if (res) {
              this.snackBar.open('Dynamic data added.' , '' , {duration: 2500});
              this.organizationTypesService.getDynamicDatas().then();
            }
          } , error => {
            this.snackBar.open('Add failed.' , '' , {duration: 2500});
          });
        }
      });

  }

  editType (type) {
    this.dialogRef = this.dialog.open(DynamicDataFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        type: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        // console.log(response);
        const actionType: string = response[ 0 ];
        const data = response[ 1 ].value;
        data.id = type.id;
        switch (actionType) {
          /**
           * Save
           */
          case 'save':


            this.organizationTypesService.addDynamicData(data).subscribe((res) => {
              if (res) {
                this.snackBar.open('Dynamic data  updated.', '', {duration: 2500});
                this.organizationTypesService.getDynamicDatas().then();
              }
            }, error => {
              this.snackBar.open('Update failed.', '', {duration: 2500});
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.organizationTypesService.deleteDynamicData(type.id).subscribe((res) => {
              if (res) {
                this.snackBar.open('Dynamic data  deleted.', '', {duration: 2500});
                this.organizationTypesService.getDynamicDatas().then();
              }
            }, error => {
              this.snackBar.open('Delete failed.', '', {duration: 2500});
            });

            break;
        }
      });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private cantonsService: DynamicDataService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.cantonsService.dynamicDatas;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.cantonsService.onDynamicDataChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.cantonsService.dynamicDatas.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      switch (this._sort.active) {
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;
        case 'text':
          [ propertyA , propertyB ] = [ a.text , b.text ];
          break;
        case 'description':
          [ propertyA , propertyB ] = [ a.description , b.description ];
          break;


      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
